import React from 'react';
import SizeAndFitAccordionContent from './SizeAndFitAccordionContent';
import BuyGridAccordion from '../../../components/BuyGridAccordion/BuyGridAccordion';
import isNotEmptyString from '../../../tools/isNotEmptyString';

export default function SizeAndFitAccordion({
  activeProduct, onClick, activeAccordion, tmntData, reviewData, eSpotContent,
}) {
  const {
    fitInformation,
    garmentMeasurements,
    hasFitInfo,
    hasGarmentMeasurements,
  } = activeProduct;

  const accordionIdentifier = 'product-size-fit__accordion';
  const hasValidEspotContent = isNotEmptyString(eSpotContent?.pdp_sizefitaccordion?.content);
  const hasValidReviewData = reviewData && reviewData.showFitRecommendation;
  const hasFitInformationSectionContent = hasFitInfo || hasValidEspotContent || hasValidReviewData;

  if (!hasFitInformationSectionContent && !hasGarmentMeasurements) return null;

  return (
    <BuyGridAccordion
      id="size-and-fit"
      headerText={tmntData.sizeAndFitAccordionHeaderText?.value}
      onClick={onClick(accordionIdentifier)}
      expanded={activeAccordion === accordionIdentifier}
    >
      <SizeAndFitAccordionContent
        textContent={tmntData}
        fitInformation={fitInformation}
        garmentMeasurements={garmentMeasurements}
        hasFitInfo={hasFitInfo}
        hasFitInformationSectionContent={hasFitInformationSectionContent}
        hasGarmentMeasurements={hasGarmentMeasurements}
        eSpotContent={eSpotContent}
        reviewData={reviewData}
      />
    </BuyGridAccordion>
  );
}
